import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../app/shared/services/loading.service';
import { TranslateService } from '../../../app/translate';
import { AppService } from '../../../app/app.service';
import { InventoryService } from '../inventory/inventory-service.service';
import { SelectionLists, CurrentSelection, Equipment, Customer, JobSite, Make, Model } from '../../../app/entities';
import { Subscription } from 'rxjs';
import { InventorySearchItems, ModelCreateInspection, SystemComponentViewModel, SystemsInInventoryViewModel } from '../inventory/inventory-models';
import { FormControl } from '@angular/forms';
//import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { System } from '../wsre-search-on-equipment/wsre-search-on-equipment.component';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../GET_NEW_UI/adapters/ordinal-date-adapter';
import { EquipmentService } from '../GET_NEW_UI/services/equipment.service';
import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { JobsiteSelectItem } from '../setup-equipment/setup-equipment.model';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wsre-quick-idler',
  templateUrl: './wsre-quick-idler.component.html',
  styleUrls: ['./wsre-quick-idler.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class WsreQuickIdlerComponent implements OnInit {
  translateSubscription: Subscription;
  userLanguage = "english";
  _loading = 0;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = "";
  _selectedEquipment: Equipment = new Equipment();
  //separatorKeysCodes = [ENTER, COMMA];

  items: SystemsInInventoryViewModel[] = [];
  inventorySearchFilter: InventorySearchItems = new InventorySearchItems(2000); // todo : should implement paged table

  equipmentCtrl: FormControl;

  filteredSystems: SystemsInInventoryViewModel[] = [];

  selectedCustomer: Customer;
  isLoading = false;
  selectedJobsite: JobSite;
  selectedMake: Make;
  selectedModel: number;
  private _listFilter: string;

  totalcount = 0;
  avaragecmu = 0;
  chainId: number;
  jobSiteID: number;
  componenetsdetails: SystemComponentViewModel[];

  SystemId:number;
  selected_customerRef:string;
  selected_jobNumber:string;
  selected_oldJobNo:string;
  selected_date: Date = new Date();
  componentList:SystemComponentViewModel[]
  modelList:JobsiteSelectItem[];
  CopymodelList:JobsiteSelectItem[];

  selectedidler:number;
  public get listFilter(): string {
    return this._listFilter;
  }
  public set listFilter(v: string) {
    this._listFilter = v;
    this.filteredSystems = this.listFilter
      ? this.performFilter(this.listFilter)
      : this.items;
  }

  performFilter(filter: string): SystemsInInventoryViewModel[] {
    filter = filter.toLowerCase();
    return this.items.filter(s => {
      // tslint:disable-next-line:no-unused-expression
      return s.SerialNumber.toLowerCase().indexOf(filter) !== -1;
    });
  }





  constructor(
    public dialogRef: MatDialogRef<WsreQuickIdlerComponent>,
    private _appService: AppService,
    private _translate: TranslateService,
    public snackBar: MatSnackBar,
    private _notification: NotificationsService,
    private _loadingService: LoadingService,
    private inventoryService: InventoryService,
    private _dialog: MatDialog,
    private _equipmentService: SetupEquipmentService,
    private ref: ChangeDetectorRef,
    private _router: ActivatedRoute, private router: Router,
    private datePipe: DatePipe
  ) { }
  ngOnInit() {
    this.SystemId = this._router.snapshot.params.id;

    // this.chainId = this._router.snapshot.params.id
    // this.jobSiteID = this._router.snapshot.params.jobsiteId

    // if(this.chainId && this.jobSiteID){

    // }

    // console.log("chainId",this.chainId)


    this._appService.setPageTitle("Inventory");
    this._loading++;
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );

    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }


  isWSREEnable: boolean = false;
  arrSystems: System[];

  private search() {
    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventorySearchFilter.PageNumber = 1;
    this.inventoryService
      .searchSystemInInventory(this.inventorySearchFilter)
      .subscribe(
        r => {
          this.items = r.ListSystemInventory;
          let _filteredSystems = r.ListSystemInventory.filter(f => f.SystemType == this.SystemId);

          //TT-2355
          console.log("filteredSystems", r)
          //check site enable for WSRE
          this.isWSREEnable = r.isWSREEnable;


          if (_filteredSystems.length > 0) {
            let arr_ = []

            let promiseSystems = _filteredSystems.map(async systems => {
              let obj_ = {}

              obj_["Id"] = systems.SystemId
              obj_["SerialNumber"] = systems.SerialNumber
              obj_["JobSiteId"] = systems.JobSiteId

              arr_.push(obj_)

              let response = await this.inventoryService
                .getSystemComponentsInfo(systems.SystemId).toPromise();
              systems.Components = response;


              return systems;

            });
            Promise.all(promiseSystems).then((res) => {
              console.log("Promise", res)
              this.filteredSystems = res
              this.filteredSystems.map(systems => {
                let totalCMU = 0;
                systems.Components.forEach(comp => {
                  this.totalcount = systems.Components.length;
                  totalCMU = comp.CMU + totalCMU;
                });

                this.avaragecmu = parseFloat((totalCMU / this.totalcount).toFixed(2));
                systems.AverageCMU = this.avaragecmu;

              })

              this.filteredSystems = res
              this.finishedLoading();
            })

            this.arrSystems = arr_

          } else {
            this.finishedLoading();
          }


        },
        error => {
          this.finishedLoading();
        }
      );
  }

  finishedLoading() {
    this._loadingService.finishedLoading();
    this.isLoading = false;
  }

  customerChanged(event: any): void {
    this.selectedCustomer = event.value;
    if (!this.selectedCustomer) {
      return;
    }
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === this.selectedCustomer.Id
    );
    this.inventorySearchFilter.CustomerId = this.selectedCustomer.Id;
    this.inventorySearchFilter.JobsiteId = 0;
    this.selectedJobsite = null;
    
    
  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.inventorySearchFilter.JobsiteId = this.selectedJobsite.Id;

  }

  makeChanged(event) {
    this.selectedMake = event.value;
    if (!this.selectedMake) {
      return;
    }
    this.inventorySearchFilter.MakeId = this.selectedMake.Id;
   
    // this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
    //   m => m.MakeId === this.selectedMake.Id
    // );

   this._equipmentService.getModelList(this.selectedMake.Id).subscribe(res=>{
     this.modelList = res;
     this.CopymodelList =res;
   });
  //  this.search();
  }




GetIdlerList(){
  this.inventoryService.GetIdlerListForSelectedModel(this.selectedModel).subscribe(res=>{
    console.log("componentlist", res)
    this.componentList = res;
  })
}

  onNoClick() {
    this.dialogRef.close(true);
  }


  onClickStartInspection(){
    //create frame 
    console.log("this.selected_idler,this.selectedJobsite.Id,this.selectedMake.Id, this.selectedModel",this.selectedidler,this.selectedJobsite.Id,this.selectedMake.Id, this.selectedModel)
    this.inventoryService.CeateFrameAndGEWForIdlerWSRE(this.selectedidler,this.selectedJobsite.Id,this.selectedMake.Id, this.selectedModel).subscribe(result=>{
      console.log("data", result)
      if(result.EqunitId>0 && result.SystemId>0){
        this.CreateIdlerInspection(result.EqunitId,result.SystemId)
      }
    })
    
  }

  CreateIdlerInspection(EqunitId:number, SysId:number) {
    console.log("JobSiteId", this.selectedJobsite.Id)
    console.log("selected_oldJobNo", this.selected_oldJobNo)
    console.log("selected_customerRef", this.selected_customerRef)
    console.log("selected_jobNumber", this.selected_jobNumber)
    console.log("selected_date", this.selected_date)

    let obj_ = new ModelCreateInspection()

    obj_["_date"] = this.selected_date
    obj_["_jobSiteId"] = this.selectedJobsite.Id
    obj_["_systemId"] =SysId
    obj_["_jobNumber"] = this.selected_jobNumber
    obj_["_customerRef"] = this.selected_customerRef
    obj_["_oldJobNo"] = this.selected_oldJobNo
    obj_["SystemTypeId"]=2
    obj_["EqunitId"]=EqunitId
    obj_["StringDate"] = this.datePipe.transform( this.selected_date, 'MM/dd/yyyy');;

    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventoryService
      .WSRECreateNewInspection(obj_)
      .subscribe(
        r => {
          console.log("r", r)

          if (r._status) {

    
            this.onNoClick()
            this.router.navigate(['/repair-estimate', r._inspectionID, 2]);

          } else {
            
          }

          this.finishedLoading();
        })



  }
  getJobNumber(event){
    const filterValue = event.target.value.toLowerCase();
    this.selected_jobNumber =filterValue 
  }
  getOldJobNumber(event){
    const filterValue = event.target.value.toLowerCase();
    this.selected_oldJobNo = filterValue
  }
  getCusRef(event){
    const filterValue = event.target.value.toLowerCase();
    this.selected_customerRef = filterValue;
  }
  changeModelAutoComplete(event){
    const filterValue = event.target.value.toLowerCase();
 
    this.modelList = this.CopymodelList.filter(option => option.Name.toLowerCase().includes(filterValue));
  }
  modelTitle:String;
  model_auto_:number;

  modelselect(modelid) {
    console.log("this.modelTitle", modelid,this.modelList)

    this.model_auto_ =this.modelList.find(f=>f.Name == modelid).Id;
    this.selectedModel = this.modelList.find(f=>f.Name == modelid).Id;
    
    console.log("model_auto_", this.model_auto_, this.selectedModel)
    this.inventorySearchFilter.ModelId = this.selectedModel;
    this.inventoryService.GetIdlerListForSelectedModel(this.selectedModel).subscribe(res=>{
      console.log("componentlist", res)
      this.componentList = res;
    })
  }
}